import t from '../labels/labelling-utils';
import {
  CONTINENTAL_CUP_MAIN,
  CONTINENTAL_CUP_MAIN_PLAY_OFF,
  CONTINENTAL_CUP_MINOR,
  CONTINENTAL_CUP_MINOR_PLAY_OFF,
  CONTINENTAL_CUP_THIRD,
  CONTINENTAL_CUP_THIRD_PLAY_OFF,
  RELEGATION,
  RELEGATION_PLAY_OUT,
  PROMOTION,
  PROMOTION_PLAY_OFF,
} from '../typings/competition';
import { CompetitionHighlight } from '../components/organisms/competition-ranking-table/competition-ranking-table';

export const rankingLegendItems = [
  { title: t('competition.ranking.th.points'), children: t('competition.ranking.th.points.fullname') },
  { title: t('competition.ranking.th.games'), children: t('competition.ranking.th.games.fullname') },
  {
    title: t('competition.ranking.th.games.won'),
    children: t('competition.ranking.th.games.won.fullname'),
  },
  { title: t('competition.ranking.th.games.draw'), children: t('competition.ranking.th.games.draw.fullname') },
  { title: t('competition.ranking.th.games.lost'), children: t('competition.ranking.th.games.lost.fullname') },
  { title: t('competition.ranking.th.goals.scored'), children: t('competition.ranking.th.goals.scored.fullname') },
  { title: t('competition.ranking.th.goals.conceded'), children: t('competition.ranking.th.goals.conceded.fullname') },
  {
    title: t('competition.ranking.th.goals.difference'),
    children: t('competition.ranking.th.goals.difference.fullname'),
  },
];

const FALLBACK_ITEM = 'fallback-item';

const rankingLegendsMap = {
  [CONTINENTAL_CUP_MAIN]: {
    children: t('competition.ranking.legend.continental-cup-main'),
    color: CONTINENTAL_CUP_MAIN,
  },
  [CONTINENTAL_CUP_MAIN_PLAY_OFF]: {
    children: t('competition.ranking.legend.continental-cup-main-play-off'),
    color: CONTINENTAL_CUP_MAIN_PLAY_OFF,
  },
  [CONTINENTAL_CUP_MINOR]: {
    children: t('competition.ranking.legend.continental-cup-minor'),
    color: CONTINENTAL_CUP_MINOR,
  },
  [CONTINENTAL_CUP_MINOR_PLAY_OFF]: {
    children: t('competition.ranking.legend.continental-cup-minor-play-off'),
    color: CONTINENTAL_CUP_MINOR_PLAY_OFF,
  },
  [CONTINENTAL_CUP_THIRD]: {
    children: t('competition.ranking.legend.continental-cup-third'),
    color: CONTINENTAL_CUP_THIRD,
  },
  [CONTINENTAL_CUP_THIRD_PLAY_OFF]: {
    children: t('competition.ranking.legend.continental-cup-third-play-off'),
    color: CONTINENTAL_CUP_THIRD_PLAY_OFF,
  },
  [RELEGATION_PLAY_OUT]: {
    children: t('competition.ranking.legend.relegation-play-out'),
    color: RELEGATION_PLAY_OUT,
  },
  [RELEGATION]: { children: t('competition.ranking.legend.relegation'), color: RELEGATION },
  [PROMOTION]: { children: t('competition.ranking.legend.promotion'), color: PROMOTION },
  [PROMOTION_PLAY_OFF]: { children: t('competition.ranking.legend.promotion-play-off'), color: PROMOTION_PLAY_OFF },
  [FALLBACK_ITEM]: { children: null, color: PROMOTION_PLAY_OFF },
};

export const getRankingLegendsByQualifications = (qualifications: CompetitionHighlight[]) =>
  qualifications
    .map((qualification) => (qualification ? rankingLegendsMap[qualification] : rankingLegendsMap[FALLBACK_ITEM]))
    .filter((elm) => Boolean(elm));
